<template>
  <div class="main-container">
    <debug v-if="$store.state.debug"></debug>
    <no-internet v-if="$store.state.noInternetScreen"></no-internet>
    <transition-group name="fade" v-else>
      <day-night-bg key="day-night-bg"
                    v-if="$store.getters.activeSlide && ($store.getters.activeSlide.type === 'donors' || $store.getters.activeSlide.type === 'title')"/>
      <leaves key="leaves"
              v-if="$store.getters.activeSlide && ($store.getters.activeSlide.type === 'donors' || $store.getters.activeSlide.type === 'title')"/>
      <donor-slide key="donor-slide"
                   v-if="$store.getters.activeSlide && ($store.getters.activeSlide.type === 'donors')"></donor-slide>
      <birthday-slide key="birthday-slide"
                      v-if="$store.getters.activeSlide && ($store.getters.activeSlide.type === 'birthday')"></birthday-slide>
      <wpd-slide key="wpd-slide"
                 v-if="$store.getters.activeSlide && ($store.getters.activeSlide.type === 'premature')"></wpd-slide>
      <doctors-slide key="doctor-slide"
                     v-if="$store.getters.activeSlide && ($store.getters.activeSlide.type === 'doctors')"></doctors-slide>
      <nurses-slide key="nurses-slide"
                    v-if="$store.getters.activeSlide && ($store.getters.activeSlide.type === 'nurses')"></nurses-slide>
      <title-slide key="title-slide"
                   v-if="$store.getters.activeSlide && ($store.getters.activeSlide.type === 'title')"></title-slide>
      <custom-slide key="custom-slide"
                    v-if="$store.getters.activeSlide && ($store.getters.activeSlide.type === 'custom')"></custom-slide>
      <mothers-slide key="doctor-slide"
                     v-if="$store.getters.activeSlide && ($store.getters.activeSlide.type === 'mothers')"></mothers-slide>
      <fathers-slide key="doctor-slide"
                     v-if="$store.getters.activeSlide && ($store.getters.activeSlide.type === 'fathers')"></fathers-slide>
    </transition-group>
  </div>
</template>

<script>

import DonorSlide from './DonorSlide'
import WpdSlide from './WpdSlide'
import TitleSlide from './TitleSlide'
import DayNightBg from './Background/DayNightBg'
import CustomSlide from './CustomSlide'
import BirthdaySlide from './BirthdaySlide'
import DoctorsSlide from './DoctorsSlide'
import NursesSlide from './NursesSlide'
import Leaves from './Background/Leaves'
import NoInternet from './NoInternet'
import Debug from './Debug'
import MothersSlide from './MothersSlide'
import FathersSlide from './FathersSlide'

export default {
  name: 'Main',
  components: {
    Debug,
    NoInternet,
    Leaves,
    BirthdaySlide,
    CustomSlide,
    DayNightBg,
    TitleSlide,
    WpdSlide,
    DonorSlide,
    DoctorsSlide,
    NursesSlide,
    MothersSlide,
    FathersSlide
  },
  data () {
    return {
      interval: ''
    }
  },
  created () {
    this.$store.dispatch('getSlides')
  },
  mounted () {
    this.loopSlides()
  },
  computed: {
    customDuration () {
      return parseInt(this.$store.getters.nextSlide.slide.slide_duration.replace('s', '')) * 1000 + 600
    }
  },
  methods: {
    loopSlides () {
      clearTimeout(this.interval)
      this.interval = setTimeout(() => {
        this.$store.dispatch('updateSlide')
          .then(() => {
            this.loopSlides()
          })
      },
      this.$store.getters.nextSlide && this.$store.getters.nextSlide.slide && this.$store.getters.nextSlide.slide.slide_duration ? this.customDuration : this.$store.state.slidesTimeout
      )
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue